/**
 * Turns flattened API column keys into readable titles (e.g. SiteId → Site Id,
 * AddressLine1 → Address Line 1).
 */

function isTimeZoneZoneShortKey(key: string): boolean {
  const lower = key.toLowerCase();
  if (!lower.includes('timezone')) {
    return false;
  }
  return /\bzone\s*short\b/i.test(key) || lower.replace(/\s/g, '').includes('zoneshort');
}

function humanizeSegment(segment: string): string {
  if (/^\[\d+\]$/.test(segment)) {
    return segment;
  }
  // Phrases already split for humans (e.g. "Postal Code", "Zone Short")
  if (segment.includes(' ') && !/[a-z][A-Z]/.test(segment)) {
    return segment;
  }
  return segment
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-zA-Z])(\d)/g, '$1 $2')
    .trim();
}

export function humanizeColumnKey(key: string): string {
  if (!key) {
    return '';
  }
  if (isTimeZoneZoneShortKey(key)) {
    return 'Time Zone';
  }
  return key
    .split(' - ')
    .map(segment => humanizeSegment(segment.trim()))
    .join(' - ');
}
